export enum SessionStorageKey {
  Search = 'search',
}
